import React from 'react';
import {Text} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import PropTypes from 'prop-types';
import styles, {tooltipGradientColors} from '../../../style/adminTools';

const TooltipBubble = ({text, full = false, testID}) => (
  <LinearGradient
    colors={tooltipGradientColors}
    style={[
      styles.settingTooltipBubble,
      full ? styles.settingTooltipBubbleFull : null
    ]}
    testID={testID}
  >
    <Text style={styles.settingTooltipText}>{text}</Text>
  </LinearGradient>
);

TooltipBubble.propTypes = {
  text: PropTypes.string.isRequired,
  full: PropTypes.bool,
  testID: PropTypes.string
};

export default TooltipBubble;
